import type { ProductMatrixApiResponse } from '@/types/matrix.interface';

export function isProductMatrixValid(result: ProductMatrixApiResponse | null): boolean {
  if (!result?.products?.length || !result?.sizeGroups?.length) {
    return false;
  }

  return true;
}
